export const headerCopy = 'Get a real offer in\u00A02\u00A0minutes';

export const subHeaderCopy = 'Sell or trade your car 100% online.\nNo haggling, no headaches.';
